export enum UserMode {
  NONE = 'NONE',
  USER_NAME = 'USER_NAME',
  USER_EMAIL = 'USER_EMAIL',
  USER_PHONE = 'USER_PHONE',
  USER_ADDRESS = 'USER_ADDRESS',
}
